import React from "react";

import PropTypes from "prop-types";
import classnames from "classnames";

import "./Terms.scss";

const Terms = ({ className = "" }) => {
	return (
		<div
			className={classnames(className, {
				"payment-terms": true,
			})}
		>
			By clicking Confirm Purchase, you agree to the
			<a
				rel="noopener noreferrer"
				target="_blank"
				href="https://okcupid.com/legal/terms"
			>
				{" "}Terms and Conditions.
			</a>
		</div>
	);
};

Terms.propTypes = {
	className: PropTypes.string,
};

Terms.defaultProps = {
	className: "",
};

export default Terms;



// WEBPACK FOOTER //
// ./src/apps/payment/components/Terms/index.jsx